import React, { useLayoutEffect, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'; //useHistory
import { Link } from 'react-router-dom'
import useJquery from 'react-use-jquery';

export default function Header() {


    const $ = useJquery();
    const history = useHistory();
    const [curPage, setCurPage] = useState(history.location.pathname);


    useEffect(() => {

        $('.btn-show-menu-mobile').on('click', function (e) {
            $('.btn-show-menu-mobile').toggleClass('is-active');
        });

        return history.listen((location) => {

            setCurPage(location.pathname)
            if ($('.btn-show-menu-mobile').hasClass('is-active')) {
                $('.btn-show-menu-mobile').click();
            }

        });

    }, [history]);


    return (
        <>

            <header id="masthead" className="header sticky-top ttm-header-style-01">
                <div className="top_bar ttm-bgcolor-darkgrey clearfix">
                    <div className="container">
                        <div className="row no-gutters">
                            <div className="col-xl-12 d-flex flex-row align-items-center">
                                <div className="top_bar_contact_item">
                                    <div className="top_bar_icon"><i className="ti ti-email" /></div><Link to="mailto:info@asraweb.com">info@asraweb.com</Link>
                                </div>
                                <div className="top_bar_contact_item">
                                    <div className="top_bar_icon"><i className="ti ti-location-pin" /></div>
                                    <Link to="https://goo.gl/maps/iQTeG3PFqFw3Z6f69" target="_blank">مشهد، میدان معلم، پلاک
                                        ۶۲</Link>
                                </div>
                                <div className="top_bar_contact_item top_bar_social ms-auto p-0">
                                    <ul className="social-icons d-flex">
                                        <li><Link target="_blank" to="https://instagram.com/asrawebco/" rel="noopener" aria-label="facebook"><i className="fa fa-instagram" /></Link></li>
                                    </ul>
                                </div>
                                <div className="top_bar_contact_item d-flex align-items-center">
                                    <div className="header_search">
                                        <Link to="#" className="btn-default"><i className="fa fa-search" /></Link>
                                        <div className="header_search_content">
                                            <div className="header_search_content_inner">
                                                <Link to="#" className="close_btn"><i className="ti ti-close" /></Link>
                                                <form id="searchbox" method="get" action="#">
                                                    <input className="search_query" type="text" id="search_query_top" name="s" placeholder="دنبال چه چیزی می گردید؟" defaultValue />
                                                    <button type="submit" className="btn close-search"><i className="ti ti-search" /></button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ttm-bg ttm-col-bgcolor-yes ttm-right-span ttm-bgcolor-skincolor ttm-textcolor-white me-auto margin_left50 padding_left15">
                                        <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
                                        <div className="layer-content">
                                            <div className="header_btn">
                                                <Link className="ttm-btn ttm-btn-size-sm ttm-btn-color-white btn-inline" style={{ fontSize: '0.8rem' }} to="/contact-us">تماس با ما</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="site-header-menu" className="site-header-menu ttm-bgcolor-white">
                    <div className="site-header-menu-inner ttm-stickable-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                                        <div className="site-branding ">
                                            <Link className="home-link" to="/" title="AsraWeb" rel="home">
                                                <img id="logo-img" height={45} width={175} className="img-fluid auto_size" src="/assets/images/logo-asraweb.svg" alt="logo-img" />
                                            </Link>
                                        </div>
                                        <div className="d-flex flex-row">
                                            <div className={`btn-show-menu-mobile menubar menubar--squeeze`} data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                                                <span className="menubar-box">
                                                    <span className="menubar-inner" />
                                                </span>
                                            </div>
                                            <nav className="main-menu menu-mobile" id="menu">
                                                <ul className="menu">
                                                    <li className={`mega-menu-item${(curPage === "/" ? " active" : "")}`}>
                                                        <Link to="/" className="mega-menu-link">صفحه اصلی</Link>
                                                    </li>
                                                    <li className="mega-menu-item" className={`mega-menu-link${(curPage === "/about-us" ? " active" : "")}`}>
                                                        <Link to="/about-us" className="mega-menu-link">درباره ما</Link>
                                                    </li>
                                                    <li className={`mega-menu-item${(curPage === "/services" || curPage === "/business-consulting" || curPage === "/webdesign" || curPage === "/online-store" || curPage === "/content-marketing" ? " active" : "")}`}>
                                                        <Link to="/services" className="mega-menu-link">خدمات</Link>
                                                        <ul className="mega-submenu">
                                                            <li><Link to="/business-consulting" className={`${(curPage === "/business-consulting" ? " active" : "")}`}>مشاوره کسب و کار</Link></li>
                                                            <li><Link to="/webdesign" className={`${(curPage === "/webdesign" ? " active" : "")}`}>طراحی انواع وب سایت های</Link></li>
                                                            <li><Link to="/online-store" className={`${(curPage === "/online-store" ? " active" : "")}`}>طراحی فروشگاه اینترنتی</Link></li>
                                                            <li><Link to="/content-marketing" className={`${(curPage === "/content-marketing" ? " active" : "")}`}>تولید/بازاریابی محتوا</Link>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li className={`mega-menu-item${(curPage === "/projects" ? " active" : "")}`}>
                                                        <Link to="/projects">نمونه کارها</Link>
                                                    </li>
                                                    <li className="mega-menu-item disabled">
                                                        <a className="disabled">وبلاگ(بزودی)</a>
                                                    </li>
                                                    <li className={`mega-menu-item${(curPage === "/contact-us" ? " active" : "")}`}>
                                                        <Link to="/contact-us">تماس با ما</Link>
                                                    </li>
                                                </ul>
                                            </nav>
                                            <div className="widget_info d-flex flex-row align-items-center justify-content-end">
                                                <div className="widget_icon ttm-textcolor-skincolor"><i className="themifyicon ti-comments" /></div>
                                                <div className="widget_content">
                                                    <h3 className="widget_title">ارتباط با کارشناسان فروش</h3>
                                                    <p className="widget_desc"><Link to="tel:+985136076022">051 3607 6022</Link>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div className='offcanvas offcanvas-start' tabIndex={-1} id="offcanvasExample" data-bs-keyboard="true" data-bs-backdrop="false" aria-labelledby="offcanvasExampleLabel">
                <div className="offcanvas-body">
                    <div className="mobile-menu-top">
                        <div className="navbar-login-mobile">
                            <div className="img-profile-menu">
                                <div class="icon-container"><i class="fa fa-user red"></i></div>
                                {/* <img src="/assets/images/profile.png" alt="پروفایل" width={150} height={150} /> */}
                            </div>
                            <div className="login-menu-mobile text-center">
                                <a className="disabled" rel="nofollow external noopener noreferrer">ورود</a>|
                                <a className="disabled" rel="nofollow external noopener noreferrer">عضویت</a>
                            </div>
                            <div className="search-menu-mobile">
                                <div className="search-menu-mobile">
                                    <form>
                                        <div className="search-header-mobile red mr-1">
                                            <i className="fa fa-search search-icon red" />
                                            <input type="text" data-placeholder="جستجو در سایت" placeholder="جستجو در سایت" className="form-control mobile-search-input" />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="menu-container">
                        <ul className="list-unstyled mobile-menu ps-0 mt-0" id="mobile-menu-container">
                            <li>
                                <Link to="/" className={`btn align-items-center offcanvas-toggle mobile-menu-link rounded${(curPage === "/" ? " active" : "")}`}>
                                    صفحه اصلی
                                </Link>
                            </li>
                            <li>
                                <Link to="/about-us" className={`btn align-items-center offcanvas-toggle mobile-menu-link rounded${(curPage === "/about-us" ? " active" : "")}`}>
                                    درباره ما
                                </Link>
                            </li>
                            <li>
                                {(curPage === "/services" || curPage === "/business-consulting" || curPage === "/webdesign" || curPage === "/online-store" || curPage === "/content-marketing") ? (
                                    <Link to="/services" className="btn btn-toggle mobile-menu-link align-items-center rounded active" data-bs-toggle="collapse" data-bs-target="#services-collapse" aria-expanded="true">
                                        خدمات
                                    </Link>
                                ) : (
                                    <Link to="/services" className="btn btn-toggle mobile-menu-link align-items-center rounded" data-bs-toggle="collapse" data-bs-target="#services-collapse" aria-expanded="false" style={{position: "relative"}}>
                                        خدمات
                                    </Link>
                                )}
                                <div className={`collapse subMenu${(curPage === "/services" || curPage === "/business-consulting" || curPage === "/webdesign" || curPage === "/online-store" || curPage === "/content-marketing" ? " show" : "")}`} id="services-collapse">
                                    <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
                                        <li><Link to="/business-consulting" className={`link-dark offcanvas-toggle mobile-sub-menu-menu-link rounded${(curPage === "/business-consulting" ? " active" : "")}`}>مشاوره کسب و
                                            کار</Link></li>
                                        <li><Link to="/webdesign" className={`link-dark offcanvas-toggle mobile-sub-menu-menu-link rounded${(curPage === "/webdesign" ? " active" : "")}`}>طراحی انواع
                                            وب سایت</Link></li>
                                        <li><Link to="/online-store" className={`link-dark offcanvas-toggle mobile-sub-menu-menu-link rounded${(curPage === "/online-store" ? " active" : "")}`}>طراحی
                                            فروشگاه اینترنتی</Link>
                                        </li>
                                        <li><Link to="/content-marketing" className={`link-dark offcanvas-toggle mobile-sub-menu-menu-link rounded${(curPage === "/content-marketing" ? " active" : "")}`}>تولید/بازاریابی
                                            محتوا</Link></li>
                                    </ul>
                                </div>
                            </li>
                            <li>
                                <Link to="/projects" className={`btn align-items-center offcanvas-toggle mobile-menu-link rounded${(curPage === "/projects" ? " active" : "")}`}>
                                    نمونه کارها
                                </Link>
                            </li>
                            <li>
                                <Link className="btn align-items-center disabled rounded">
                                    وبلاگ(بزودی)
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact-us" className={`btn align-items-center offcanvas-toggle mobile-menu-link rounded${(curPage === "/contact-us" ? " active" : "")}`}>
                                    تماس با ما
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </>
    )
}
